<template>
  <div class="search-page">
    <div class="searchMonth">
      <span>请选择查询的月份：</span>
      <el-date-picker
        v-model="selectMonthValue"
        type="month"
        value-format='yyyy-MM'
        :editable='editableS'
        :readonly='timerreadonlys'
        placeholder="请选择月">
      </el-date-picker>
      <el-button type="primary" class="searchA" @click='searchMonthDetail()'>查  询</el-button>
    </div>
    <el-table
    class="searchTable"
    :data="searchTableData"
    border
    style="width: 100%">
    <el-table-column
      fixed
      label="序列号"
      width="70"
      type="index"
      :index="indexMethod">
    </el-table-column>
    <el-table-column
      prop="exam_id"
      label="试题ID"
      width="360">
    </el-table-column>
    <el-table-column
      prop="title"
      label="测试主题"
      width='150'>
    </el-table-column>
    <el-table-column
      prop="push_date"
      label="起始时间"
      width="260">
    </el-table-column>
    <el-table-column
      prop="invalidTime"
      label="截止时间"
      width="260">
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button @click.stop="shutdown(scope.$index, scope.row, scope.store)" :disabled='scope.row.status == "off"' type="text" size="small">
          {{scope.row.status == "off" ? "已关闭" : "关闭"}}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>

<script>
import address from '@/libs/address'
export default{
  name: 'SearchPage',
  props: [],
  data() {
    return {
      selectMonthValue: '',
      editableS: false,
      timerreadonlys: false,
      searchTableData: [],
      userId: '',
      casCookie: '',
      sessionId: ''
    }
  },
  computed: {
  },
  created () {
    this.userId = this.$route.query.userId;
    this.casCookie = this.$route.query.casCookie;
    this.sessionId = this.$route.query.sessionId;
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    shutdown(oIndex, orow, ostore) {
      // console.log(oIndex, orow, ostore);
      const exam_id = orow.exam_id
      const status = 'off'
      const loading = this.$loading({
            lock: true,
            text: '关闭中,请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)',
            customClass: 'searchApplyLoading'
        });
        this.$get(address.changeStatus, {
          userId: this.userId,
          casCookie: this.casCookie,
          sessionId: this.sessionId,
          examCloseId: exam_id,
          status: status
        }).then((res) => {
          loading.close();
          if (!res.errorCode && res.errorCode == 0) {
            this.$message.success('测试题关闭成功！！');
            orow.status = 'off';
          } else if (res.errorCode == 9999) {
            this.$message.error('会话过期，请重新登录！');
            this.$router.push({path: '/login'});
          } else {
            this.$message.error('测试题关闭失败');
          }
        }).catch((err) => {
          loading.close();
          this.$message.error('网络错误, 请检查网络是否正常！');
        });
    },
    searchMonthDetail() {
      this.applyData(this.selectMonthValue);
    },
    applyData(dataValue) {
      const loading = this.$loading({
            lock: true,
            text: '数据加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.2)',
            color: 'red',
            customClass: 'searchLoading'
        });
        this.$get(address.searchItems, {
          userId: this.userId,
          casCookie: this.casCookie,
          sessionId: this.sessionId,
          closeDate: dataValue
        }).then((res) => {
          loading.close();
          if (!res.errorCode && res.errorCode == 0) {
            this.$message.success('数据加载成功！');
            this.searchTableData = res.data;
          } else if (res.errorCode == 9999) {
            this.$message.error('会话过期，请重新登录！');
            this.$router.push({path: '/login'});
          } else {
            this.$message.error('数据加载失败, 请刷新页面重试！');
          }
        }).catch((err) => {
          loading.close();
          this.$message.error('网络错误, 请检查网络是否正常！');
        });
      }
  },
  mounted() {
    let currentDate = new Date();
    const year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    month = month.toString();
    if (month.length == 1) {
      month = '0' + month
    }
    const fullDate = year + '-' + month;
    this.selectMonthValue = fullDate;
    this.applyData(this.selectMonthValue);
  }
}
</script>

<style lang='scss' scoped>
@import '~@/common/mixin.scss';

.search-page {
  text-align: left;
  font-size: 14px;
  margin-top: 10px;
  .searchMonth {
    .searchA {
      margin-left: 20px;
      background-color: #003c8d;
      border-color: #003c8d;
      &:active {
        background: rgba(0, 60, 141, 0.9);
        border-color: rgba(0, 60, 141, 0.9);
      }
    }
  }
  .searchTable {
    margin-top: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SearchPage.vue